// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AudioBookCarousel_container__0N95i {
  width: 100%;
  max-width: 95%;
  margin: 0 auto;
  overflow: hidden;
  margin-bottom: 10px;
  padding: 0;
}

.AudioBookCarousel_header__B0fZC {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 20px;
  padding: 0;
  flex-wrap: wrap;
  position: relative;
}

.AudioBookCarousel_title__lsfV7 {
  color: white;
  font-size: 20px;
  margin: 0;
}

.AudioBookCarousel_categories__bQWMD {
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-bottom: 8px;
  -webkit-overflow-scrolling: touch;
}

.AudioBookCarousel_categories__bQWMD::-webkit-scrollbar {
  display: none;
}

.AudioBookCarousel_categoryBtn__-jWww {
  background: none;
  border: 2px solid transparent;
  color: #888;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s ease;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  flex-shrink: 0;
}

.AudioBookCarousel_categoryBtn__-jWww::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 59, 59, 0.1);
  transform: scaleX(0);
  transform-origin: right;
  transition: transform 0.3s ease;
}

.AudioBookCarousel_categoryBtn__-jWww:hover::before {
  transform: scaleX(1);
  transform-origin: left;
}

.AudioBookCarousel_categoryBtn__-jWww.AudioBookCarousel_active__ohYW9 {
  color: white;
  border-color: #ff0000;
  background: #ff0000;
}

.AudioBookCarousel_navigation__3Mn4m {
  display: flex;
  gap: 8px;
}

.AudioBookCarousel_navBtn__sbM5c {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  transition: background-color 0.3s ease;
}

.AudioBookCarousel_navBtn__sbM5c:hover {
  background: rgba(255, 255, 255, 0.2);
}

.AudioBookCarousel_swiper__Pu-dV {
  width: 100%;
  padding: 0;
  margin: 0;
}

.AudioBookCarousel_slide__dgTzh {
  width: auto;
  margin: 0;
  padding: 0;
}

.AudioBookCarousel_card__1dKy2 {
  width: 100%;
  background: #242424;
  overflow: hidden;
  transition: transform 0.3s ease;
  position: relative;
  margin: 0;
  border-radius: 10px;
  padding-top: 10px;
}


.AudioBookCarousel_imageWrapper__H27Cd {
  position: relative;
  width: 95%;
  padding-top: 100%;
  margin: auto;
}

.AudioBookCarousel_image__ikbqp {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.AudioBookCarousel_category__ddQUZ {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 16px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(5px);
  z-index: 1;
}

.AudioBookCarousel_playButton__dW9um {
  position: absolute;
  right: 16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ff0000;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.3s ease;
}



.AudioBookCarousel_info__RHrDH {
  padding: 10px;
  display: flex;
  align-items: center;
}

.AudioBookCarousel_bookTitle__VZX\\+z {
  color: white;
  margin: 0 0 8px 0;
  font-size: 18px;
}

.AudioBookCarousel_subtitle__ZpyCn {
  color: #888;
  margin: 0 0 12px 0;
  font-size: 14px;
}

.AudioBookCarousel_duration__T7MXT {
  color: #666;
  font-size: 12px;
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 10px;
  gap: 8px;
  border: 1px solid black;
  background-color: black;
}

.AudioBookCarousel_duration__T7MXT span {
  display: flex;
  align-items: center;
  gap: 5px;
}

@media (max-width: 768px) {

  
  .AudioBookCarousel_header__B0fZC {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .AudioBookCarousel_title__lsfV7 {
    font-size: 20px;
  }

  .AudioBookCarousel_categories__bQWMD {
    order: 2;
    width: 100%;
    margin-bottom: 5px;
    gap: 4px;
  }

  .AudioBookCarousel_categoryBtn__-jWww {
    padding: 6px 12px;
    font-size: 14px;
  }

  .AudioBookCarousel_navigation__3Mn4m {
    position: absolute;
    right: 0;
    top: 0;
  }
  
  .AudioBookCarousel_navBtn__sbM5c {
    width: 32px;
    height: 32px;
  }
  
  .AudioBookCarousel_navIcon__Kyg-T {
    width: 18px;
    height: 18px;
  }

  .AudioBookCarousel_playButton__dW9um {
    width: 36px;
    height: 36px;
    right: 12px;
  }
  
  .AudioBookCarousel_playIcon__-oT6g {
    width: 18px;
    height: 18px;
  }
  
  .AudioBookCarousel_durationIcon__CCwUK {
    width: 12px;
    height: 12px;
  }

  .AudioBookCarousel_duration__T7MXT {
    font-size: 12px;
    padding: 4px;
    gap: 4px;
  }
  
  .AudioBookCarousel_duration__T7MXT span {
    gap: 3px;
  }

  .AudioBookCarousel_card__1dKy2 {
    width: 100%;
    margin: 0;
  }
  
  .AudioBookCarousel_info__RHrDH {
    padding: 12px;
  }
}

@media (max-width: 480px) {
 
  
  .AudioBookCarousel_title__lsfV7 {
    font-size: 18px;
  }
  
  .AudioBookCarousel_header__B0fZC {
    margin-bottom: 5px;
  }

  .AudioBookCarousel_categoryBtn__-jWww {
    padding: 4px 10px;
    font-size: 12px;
    border-radius: 16px;
  }

  .AudioBookCarousel_navBtn__sbM5c {
    width: 28px;
    height: 28px;
  }
  
  .AudioBookCarousel_navIcon__Kyg-T {
    width: 16px;
    height: 16px;
  }

  .AudioBookCarousel_playButton__dW9um {
    width: 30px;
    height: 30px;
    right: 10px;
  }
  
  .AudioBookCarousel_playIcon__-oT6g {
    width: 16px;
    height: 16px;
  }

  .AudioBookCarousel_category__ddQUZ {
    font-size: 10px;
    padding: 3px 6px;
    top: 10px;
    right: 10px;
  }
  
  .AudioBookCarousel_info__RHrDH {
    padding: 10px;
  }
  .AudioBookCarousel_duration__T7MXT{
    font-size: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Homepage/components/Css/AudioBookCarousel.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,oBAAoB;EACpB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;AACjC;;;;AAIA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,MAAM;EACR;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;;EAGE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":[".container {\n  width: 100%;\n  max-width: 95%;\n  margin: 0 auto;\n  overflow: hidden;\n  margin-bottom: 10px;\n  padding: 0;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  gap: 20px;\n  padding: 0;\n  flex-wrap: wrap;\n  position: relative;\n}\n\n.title {\n  color: white;\n  font-size: 20px;\n  margin: 0;\n}\n\n.categories {\n  display: flex;\n  gap: 8px;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  padding-bottom: 8px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.categories::-webkit-scrollbar {\n  display: none;\n}\n\n.categoryBtn {\n  background: none;\n  border: 2px solid transparent;\n  color: #888;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: all 0.3s ease;\n  border-radius: 20px;\n  position: relative;\n  overflow: hidden;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.categoryBtn::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 59, 59, 0.1);\n  transform: scaleX(0);\n  transform-origin: right;\n  transition: transform 0.3s ease;\n}\n\n.categoryBtn:hover::before {\n  transform: scaleX(1);\n  transform-origin: left;\n}\n\n.categoryBtn.active {\n  color: white;\n  border-color: #ff0000;\n  background: #ff0000;\n}\n\n.navigation {\n  display: flex;\n  gap: 8px;\n}\n\n.navBtn {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: white;\n  transition: background-color 0.3s ease;\n}\n\n.navBtn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.swiper {\n  width: 100%;\n  padding: 0;\n  margin: 0;\n}\n\n.slide {\n  width: auto;\n  margin: 0;\n  padding: 0;\n}\n\n.card {\n  width: 100%;\n  background: #242424;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n  position: relative;\n  margin: 0;\n  border-radius: 10px;\n  padding-top: 10px;\n}\n\n\n.imageWrapper {\n  position: relative;\n  width: 95%;\n  padding-top: 100%;\n  margin: auto;\n}\n\n.image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.category {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 6px 12px;\n  border-radius: 16px;\n  color: white;\n  font-size: 14px;\n  font-weight: 500;\n  backdrop-filter: blur(5px);\n  z-index: 1;\n}\n\n.playButton {\n  position: absolute;\n  right: 16px;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #ff0000;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n\n\n.info {\n  padding: 10px;\n  display: flex;\n  align-items: center;\n}\n\n.bookTitle {\n  color: white;\n  margin: 0 0 8px 0;\n  font-size: 18px;\n}\n\n.subtitle {\n  color: #888;\n  margin: 0 0 12px 0;\n  font-size: 14px;\n}\n\n.duration {\n  color: #666;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  border-radius: 10px;\n  gap: 8px;\n  border: 1px solid black;\n  background-color: black;\n}\n\n.duration span {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n@media (max-width: 768px) {\n\n  \n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .title {\n    font-size: 20px;\n  }\n\n  .categories {\n    order: 2;\n    width: 100%;\n    margin-bottom: 5px;\n    gap: 4px;\n  }\n\n  .categoryBtn {\n    padding: 6px 12px;\n    font-size: 14px;\n  }\n\n  .navigation {\n    position: absolute;\n    right: 0;\n    top: 0;\n  }\n  \n  .navBtn {\n    width: 32px;\n    height: 32px;\n  }\n  \n  .navIcon {\n    width: 18px;\n    height: 18px;\n  }\n\n  .playButton {\n    width: 36px;\n    height: 36px;\n    right: 12px;\n  }\n  \n  .playIcon {\n    width: 18px;\n    height: 18px;\n  }\n  \n  .durationIcon {\n    width: 12px;\n    height: 12px;\n  }\n\n  .duration {\n    font-size: 12px;\n    padding: 4px;\n    gap: 4px;\n  }\n  \n  .duration span {\n    gap: 3px;\n  }\n\n  .card {\n    width: 100%;\n    margin: 0;\n  }\n  \n  .info {\n    padding: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n \n  \n  .title {\n    font-size: 18px;\n  }\n  \n  .header {\n    margin-bottom: 5px;\n  }\n\n  .categoryBtn {\n    padding: 4px 10px;\n    font-size: 12px;\n    border-radius: 16px;\n  }\n\n  .navBtn {\n    width: 28px;\n    height: 28px;\n  }\n  \n  .navIcon {\n    width: 16px;\n    height: 16px;\n  }\n\n  .playButton {\n    width: 30px;\n    height: 30px;\n    right: 10px;\n  }\n  \n  .playIcon {\n    width: 16px;\n    height: 16px;\n  }\n\n  .category {\n    font-size: 10px;\n    padding: 3px 6px;\n    top: 10px;\n    right: 10px;\n  }\n  \n  .info {\n    padding: 10px;\n  }\n  .duration{\n    font-size: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AudioBookCarousel_container__0N95i`,
	"header": `AudioBookCarousel_header__B0fZC`,
	"title": `AudioBookCarousel_title__lsfV7`,
	"categories": `AudioBookCarousel_categories__bQWMD`,
	"categoryBtn": `AudioBookCarousel_categoryBtn__-jWww`,
	"active": `AudioBookCarousel_active__ohYW9`,
	"navigation": `AudioBookCarousel_navigation__3Mn4m`,
	"navBtn": `AudioBookCarousel_navBtn__sbM5c`,
	"swiper": `AudioBookCarousel_swiper__Pu-dV`,
	"slide": `AudioBookCarousel_slide__dgTzh`,
	"card": `AudioBookCarousel_card__1dKy2`,
	"imageWrapper": `AudioBookCarousel_imageWrapper__H27Cd`,
	"image": `AudioBookCarousel_image__ikbqp`,
	"category": `AudioBookCarousel_category__ddQUZ`,
	"playButton": `AudioBookCarousel_playButton__dW9um`,
	"info": `AudioBookCarousel_info__RHrDH`,
	"bookTitle": `AudioBookCarousel_bookTitle__VZX+z`,
	"subtitle": `AudioBookCarousel_subtitle__ZpyCn`,
	"duration": `AudioBookCarousel_duration__T7MXT`,
	"navIcon": `AudioBookCarousel_navIcon__Kyg-T`,
	"playIcon": `AudioBookCarousel_playIcon__-oT6g`,
	"durationIcon": `AudioBookCarousel_durationIcon__CCwUK`
};
export default ___CSS_LOADER_EXPORT___;
